import { env } from '@/env';
import { RouteName } from '@/router/route-names';

// Include dev routes in dev mode OR in non-prod environments (intg, stge)
const includeDevRoutes = env.isDev || ['intg', 'stge', 'integration', 'staging'].includes(env.VUE_APP_ENV?.toLowerCase());

export const devRoutes = includeDevRoutes ? [{
    path: '/tools/dev/frameTest',
    name: RouteName.frameTest,
    component: () => import('@/entry/FrameTest.vue'),
},
{
    name: RouteName.mergeTest,
    path: '/:coachId?/:appId/merge',
    meta: { title: 'routes.mergeTest' },
    component: () => import('@/play-editor/MergeTestPage.vue'),
    props: true,
}] : [];
